export const INVALID_CHARACTERS_IN_MFG_NAME = 'Manufacturer Name supported characters are letters, numbers, and common special characters.'